import { Style, TargetOptionType, InputType } from 'common/questionnaires/types';

export const createNewQuestionCardData = (id, question) => ({ id, cardQuestions: [question] });

export const shapeQuestionsForQuestionCards = (questionsInput) => {
  if (!questionsInput || !Array.isArray(questionsInput) || (Array.isArray(questionsInput) && questionsInput.length === 0)) {
    return [];
  }
  const newQuestionCardsData = [createNewQuestionCardData('QC0', questionsInput[0])];

  for (let i = 1, questionCardIndex = 0; i < questionsInput.length; i += 1) {
    if (questionsInput[i].style === Style.Embedded || questionsInput[i].style === Style.Collapsible) {
      newQuestionCardsData[questionCardIndex].cardQuestions.push(questionsInput[i]);
    } else {
      questionCardIndex += 1;
      newQuestionCardsData.push(createNewQuestionCardData(`QC${ questionCardIndex }`, questionsInput[i]));
    }
  }

  return newQuestionCardsData;
};

export const loadQuestionFromMatrixById = (questions, id) => {
  if (!questions) {
    return null;
  }
  const question = questions.find(q => q.id === id);
  if (question != null && question !== undefined) {
    return Object.assign({}, question);
  }
  return null;
};

export const loadQuestionByIndex = (questions, index) => {
  if (questions && questions.length >= index) {
    return Object.assign({}, questions[index]);
  }
  return {};
};

export const loadNextQuestion = (questions, currentQuestion, mode) => {
  if (!currentQuestion) {
    return null;
  }

  switch (currentQuestion.target.type) {
    case InputType.Select: {
      const nextQuestion = loadQuestionFromMatrixById(questions, currentQuestion.target.buttonTargets[currentQuestion.answer].nextQuestionId);
      if (nextQuestion != null) {
        return nextQuestion;
      }
      return null;
    }
    case InputType.YesNo: {
      const nextQuestion = loadQuestionFromMatrixById(questions, currentQuestion.target.buttonTargets[currentQuestion.answer].nextQuestionId);
      if (nextQuestion != null) {
        return nextQuestion;
      }
      return null;
    }
    case InputType.TextFields: {
      const nextQuestion = loadQuestionFromMatrixById(questions, currentQuestion.target.target.nextQuestionId);
      if (nextQuestion != null) {
        return nextQuestion;
      }
      return null;
    } default:
      throw new Error('Invalid target type setup');
  }
};

export const loadAnswer = (currentQuestion, mode) => {
  if (!currentQuestion) {
    return null;
  }

  switch (currentQuestion.target.type) {
    case InputType.Select:
    case InputType.YesNo: {
      const answerOption = currentQuestion.target.buttonTargets[currentQuestion.answer];
      if (answerOption && answerOption.formType && answerOption.type === TargetOptionType.Form) {
        return answerOption;
      }
      return null;
    }
    case InputType.TextFields: {
      const answerOption = currentQuestion.target.target;
      if (answerOption && answerOption.formType && answerOption.type === TargetOptionType.Form) {
        return answerOption;
      }
      return null;
    } default:
      throw new Error('Invalid target type setup');
  }
};
